<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 18" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2802 2.68143H0.778442V0.681427H20.2802V2.68143Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2802 17.6222H0.778442V15.6222H20.2802V17.6222Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.2802 10.1518H6.01941V8.15176H20.2802V10.1518Z" fill="currentColor"/>
    </svg>
</template>